import React from 'react'
import { Container } from '@shared/components/container'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import { AboutCredit } from '@shared/components/sections/about-credit'
import { CreditAlternative } from '@shared/components/sections/credit-alternative'
import { CreditConditions } from '@shared/components/sections/credit-conditions'
import { CreditRepaymentMethods } from '@shared/components/sections/credit-repayment-methods'
import { Process } from '@shared/components/sections/process'
import { Tabs } from '@shared/components/tabs'
import HouseInShape from '@shared/svg/in-shape/house.svg'
import PercentInShape from '@shared/svg/in-shape/percent.svg'
import RubInShape from '@shared/svg/in-shape/rub.svg'
import ValtInShape from '@shared/svg/in-shape/valt.svg'

export const AboutLoan = () => {
	return (
		<Container className='mb-xl'>
			<Tabs
				data={[
					{
						tabTitle: 'О кредите',
						TabComponent: () =>
							AboutCredit({
								title: (
									<>
										Взять кредит на покупку дома или земельного участка можно без первоначального
										взноса, скрытого страхования и походов в банк. Сделка в Credit.Club оформляется
										в&nbsp;цифровом формате. Полученные деньги можно использовать для приобретения
										любого дома в России — нет ограничений по выбору недвижимости.
									</>
								),
								rateMode: 'pledge',
								customPercent: '14,9',
								points: [
									{
										IconSvg: HouseInShape,
										title: 'До 15 млн',
										text: 'на покупку дома или земельного участка. Полученные деньги можно использовать в том числе на ремонт недвижимости',
									},
									{
										IconSvg: RubInShape,
										title: 'От 14,9%',
										text: 'ставка фиксирована договором. Без скрытых платежей и комиссий. Перечисляем деньги на счёт любого банка через 1–2 дня после регистрации сделки',
									},
									{
										IconSvg: PercentInShape,
										title: 'До 20 лет',
										text: 'с комфортным ежемесячным платежом. Возможно досрочное погашение кредита',
									},
									{
										IconSvg: ValtInShape,
										title: '0 рублей',
										text: 'на первоначальный взнос. Не придётся ждать, пока накопится нужная сумма',
									},
								],
							}),
					},
					{
						tabTitle: 'Альтернатива ипотеке',
						TabComponent: () =>
							CreditAlternative({
								title: <>Комфортная альтернатива ипотеке на&nbsp;покупку дома в&nbsp;банке</>,
							}),
					},
					{
						tabTitle: 'Условия',
						TabComponent: () => CreditConditions({}),
					},
					{
						tabTitle: 'Как оформить',
						TabComponent: () =>
							Process({
								title: 'Как оформить',
								subtitle: 'Простой процесс получения кредита до 15 млн на покупку частного дома',
								points: [
									{
										title: 'Заполните онлайн-заявку',
										text: 'Предварительное решение сформируем за полчаса',
									},
									{
										title: 'Загрузите документы',
										text: 'В личном кабинете не выходя из дома или офиса',
									},
									{
										title: 'Встретьтесь с менеджером',
										text: 'Наш представитель приедет в удобное для вас время с пакетом документов для подписи и расскажет о дальнейших действиях',
									},
									{
										title: 'Получите деньги',
										text: 'Сумму переведём на счёт в любом банке',
									},
								],
								onButtonClick: scrollToApplicationForm,
							}),
					},
					{
						tabTitle: 'Способы погашения',
						TabComponent: () => CreditRepaymentMethods({}),
					},
				]}
			/>
		</Container>
	)
}
